module.exports = __webpack_public_path__ + "static/media/01-print-ad.f37b1adc.png";